// src/Redux/slices/pricingSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { apiEndpoints } from "../../services/apiConfig";

// ✅ Async thunk to fetch subscription plans
export const fetchSubscriptions = createAsyncThunk(
  "pricing/fetchSubscriptions",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(apiEndpoints.getallPricePlane);
      return response.data; 
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch subscriptions"
      );
    }
  }
);

const pricingSlice = createSlice({
  name: "pricing",
  initialState: {
    subscriptions: {},
    plansloading: false,
    error: null,
  },
  reducers: {
    clearPricingError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSubscriptions.pending, (state) => {
        state.plansloading = true;
        state.error = null;
      })
      .addCase(fetchSubscriptions.fulfilled, (state, action) => {
        state.plansloading = false;
        state.subscriptions = action.payload;
      })
      .addCase(fetchSubscriptions.rejected, (state, action) => {
        state.plansloading = false;
        state.error = action.payload;
      });
  },
});

export const { clearPricingError } = pricingSlice.actions;

export default pricingSlice.reducer;
